import React, { useRef } from 'react';
import { useCodeMirror } from '../hooks/useCodeMirror';
import type { LanguageId } from '../types/language';

interface EditorProps {
  code: string;
  onChange: (code: string) => void;
  onRun?: () => void;
  theme?: 'light' | 'dark';
  language?: LanguageId;
}

export const Editor: React.FC<EditorProps> = ({ 
  code, 
  onChange, 
  onRun, 
  theme = 'light',
  language = 'python'
}) => {
  const editorRef = useRef<HTMLDivElement>(null);
  
  useCodeMirror({
    containerRef: editorRef,
    code,
    onChange,
    onRun,
    theme,
    language
  });

  return <div ref={editorRef} className="panel editor-panel" />;
};